import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export function useContactsApi() {
  const { apiFetch } = useAuth();

  return useMemo(
    () => ({
      getAll: () => apiFetch("/contacts"),

      googleSync: (id) =>
        apiFetch(`/contacts/${id}/google-sync`, { method: "POST" }),

      create: (data) =>
        apiFetch("/contacts", {
          method: "POST",
          body: JSON.stringify(data),
        }),

      update: (id, data) =>
        apiFetch(`/contacts/${id}`, {
          method: "PUT",
          body: JSON.stringify(data),
        }),

      remove: (id) =>
        apiFetch(`/contacts/${id}`, {
          method: "DELETE",
        }),
    }),
    [apiFetch],
  );
}
